import * as http from '@/utils/http.js';

/**
 * 考培客户信息
 * @param {Number} id
 * @return {Promise<Array>}
 */
export function getCustomerById(id) {
  return http._get({
    url: `/training/customer/resource/id/${id}`,
  });
}

/**
 * 重复资源信息
 *
 * @param {Number} id
 */
export function getSnapshotById(id) {
  return http._get({
    url: `/training/customer/snapshot/id/${id}`,
  });
}

export default {
  getCustomerById,
  getSnapshotById
};
